/* eslint-disable @typescript-eslint/naming-convention */
import { Image as InnerImageRef } from './image.tools';
import * as rxjsTools from './rxjs.tools';
import { Url as InnerUrlRef } from './url.tools';
import { Utils as InnerUtilsRef } from './utils.tools';

/**
 * Utils and tools to aid development.
 */
export namespace Tools {
    export const Image = InnerImageRef;
    export const RxJs = rxjsTools;
    export const Url = InnerUrlRef;
    export const Utils = InnerUtilsRef;
}
